import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { hydrate } from 'react-dom';
import { Page } from 'hedron';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ThemeProvider } from '@devfolioco/genesis';
import { Analytics } from '@devfolioco/helpers';
import Loadable from 'react-loadable';
import React from 'react';

import ErrorBoundary from './components/ErrorBoundary';
import Normalize from './components/Normalize';

import * as Sentry from './helpers/sentry';
import { history } from './helpers/history';
import { printHiringLog, getAnalyticsUserInfo } from './helpers';
import { SEGMENT_ENABLED } from './constants/settings';
import QuizRoutes from './quizRoutes';

import store from '../shared/store';

Sentry.init();

Analytics.init({
  userDetailsFetcher: getAnalyticsUserInfo,
  enabled: SEGMENT_ENABLED,
});

printHiringLog();

Loadable.preloadReady().then(() => {
  hydrate(
    <Provider store={store}>
      <Router history={history}>
        <ThemeProvider>
          <Page fluid className="ui-container">
            <Normalize />
            <ErrorBoundary>
              <QuizRoutes />
            </ErrorBoundary>
          </Page>
        </ThemeProvider>
      </Router>
    </Provider>,
    document.getElementById('root')
  );
});
